var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-overlay",class:{ 'v-overlay--active': _vm.value }},[(_vm.value)?_c('div',{staticClass:"h-max"},[_c('div',{staticClass:"d-flex justify-center align-center h-max"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }